import {parseToken} from "./UtilityService";

export const getReportData = (params) => {
    const {token = ''} = params;

    let data = parseToken(token);

    const questions = data.questions;
    data.child.questions = questions;

    if(data.parent){
        data.parent.questions = questions;
    }

    return data;
};

export default {
    getReportData,
}